import { Component,QueryList,OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pujan-qr-scan',
  templateUrl: './pujan-qr-scan.component.html',
  styleUrls: ['./pujan-qr-scan.component.scss']
})
export class PujanQrScanComponent implements OnInit {
visitorDetails: any;
  @ViewChild('autofocus', { static: false }) textAreas: ElementRef;

  bookingNo = '';
  public onChangeSearch = new Subject<string>();
  public errorMsg = '';
  public successMsg = '';
  public loading = false;
  public env: any = environment;

  constructor(
  private appComponent: AppComponent,
  private apiService: ApiService,
  ) { }

  ngOnInit() {
    this.onChangeSearch
    .pipe(debounceTime(1500))
    .subscribe(() => {
      this.bookingNo = this.bookingNo.trim();
      if(this.bookingNo){
        if (this.bookingNo && this.bookingNo.length > 8 && this.bookingNo.substring(0, 18) == 'Registration ID : ') {
          this.bookingNo = this.bookingNo.substring(18);
        }
        this.getVisitorDetail();
      }
    });
  }
  getVisitorDetail(bookingNo?,element?){
    this.loading = true;
   
    this.errorMsg = '';
    if((this.bookingNo && this.bookingNo.length == 6) || bookingNo) {
      let formObj = {
        booking_no : bookingNo ? bookingNo : this.bookingNo
      };
     this.appComponent.showLoader();
     this.apiService.postDataToServer('/puja_booking_qr_scans', formObj).subscribe(
       (res:any) => {
         if(bookingNo){
           element.verify = true
         } else{
          this.visitorDetails = res && res.data ? res.data : res;
         }
         this.appComponent.showMessageAlert(res['message'], 'success');
        this.appComponent.hideLoader();
        this.errorMsg = '';
        this.loading = false;
        this.successMsg = res['message'];
       },
       err => {
        this.errorMsg = err.error.error[0].message;
         this.appComponent.hideLoader();
         this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
         console.log(err);
         this.loading = false;
       }
     );
    } else {
      this.errorMsg = 'Invalid Qr-Code!'
      this.loading = false;
    }

  }

  verify() {
    this.bookingNo = '';
    this.errorMsg = '';
    this.textAreas.nativeElement.focus();
    this.visitorDetails = null;
    this.successMsg = '';
  }

  public changeSearchValue(): void {
    this.successMsg = '';
    this.loading = true;
    this.visitorDetails = null;
    this.errorMsg = '';
    this.onChangeSearch.next();
  }

}
